var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYoutubeSmall = function SvgYoutubeSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "youtube"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 18",
    x: 0.186523,
    y: 0.5,
    width: 26,
    height: 26,
    rx: 3.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.8104 9.26917C21.6034 8.51066 20.9934 7.91328 20.219 7.71055C18.8153 7.34216 13.1865 7.34216 13.1865 7.34216C13.1865 7.34216 7.5578 7.34216 6.15404 7.71055C5.3796 7.91331 4.76967 8.51066 4.56265 9.26917C4.18652 10.644 4.18652 13.5125 4.18652 13.5125C4.18652 13.5125 4.18652 16.381 4.56265 17.7558C4.76967 18.5143 5.3796 19.0868 6.15404 19.2896C7.5578 19.658 13.1865 19.658 13.1865 19.658C13.1865 19.658 18.8153 19.658 20.219 19.2896C20.9934 19.0868 21.6034 18.5143 21.8104 17.7558C22.1865 16.381 22.1865 13.5125 22.1865 13.5125C22.1865 13.5125 22.1865 10.644 21.8104 9.26917ZM11.3456 16.1169V10.9081L16.0501 13.5126L11.3456 16.1169Z",
    fill: "#0A0A0A"
  }))));
};
export default SvgYoutubeSmall;